import { DraftConfiguration, DraftConfigurationColor, DraftState } from '@/types';
import { getConfiguration } from '@/model/draft/getConfiguration';
import { preventUnprintableColorCombinations } from '@/model/printType/preventUnprintableColorCombinations';

export const setPrintColorAction =
  ({ cid }: DraftConfiguration, color: DraftConfigurationColor, layerIndex = 0) =>
  (draft: DraftState) => {
    const configuration = getConfiguration(draft, cid);

    configuration.printColors[layerIndex] = color;

    preventUnprintableColorCombinations(configuration.printColors, color);
  };
